import { FaTrophy } from "react-icons/fa6";
import { PiCertificateBold } from "react-icons/pi";

export const certificationsAndAwardsData = [
{
    icon: <PiCertificateBold />,
    text: "McKinsey.org Forward Program – Earned a professional development certification from McKinsey & Company (2025), gaining practical skills in structured problem-solving, effective communication, digital proficiency, and adaptive workplace mindsets.",
    link: "https://www.credly.com/badges/84c728df-2ea1-449d-8938-4b5a8ade05c7/linked_in_profile"
  },
  {
    icon: <FaTrophy />,
    text: "Tatva Award - Recognised by ICICI Prudential Life Insurance Company Limited (2024) in the IT category for Best Agent in Group Pricing, showcasing exceptional contributions and technical expertise in software development.",
    link: "https://drive.google.com/file/d/18vAtuNBFi3xu8rStDxcvc0useBlWv-25/view?usp=sharing"
  },
  {
    icon: <FaTrophy />,
    text: "Best IOne Ranger Award - Recognised by Hansa Solutions India Pvt. Ltd. during the Hansa Annual Awards 2024, acknowledging excellence in software innovation and outstanding performance.",
    link: "https://drive.google.com/file/d/1i8zClmo4gCIvv3JqcT-1v6DFDJ0FWJ9i/view?usp=sharing"
  },
  {
    icon: <PiCertificateBold />,
    text: "Web Development (MERN Stack) - Successfully completed a 4.5-month bootcamp by CodeHelp, mastering full-stack development using MongoDB, Express.js, React.js, and Node.js.",
    link: "https://learn.codehelp.in/share-certificate?serialno=HQK3BPJU",
  },
  {
    icon: <PiCertificateBold />,
    text: "Low-Level Design (LLD) - Completed an intensive 4-month bootcamp by CodeHelp, focusing on design principles and scalable software architecture.",
    link: "https://learn.codehelp.in/share-certificate?serialno=UCVWWZY7"
  }
];
